import { useCallback } from 'react';

export const useFocusInput = () => {
  return useCallback(() => {
    const textarea = document.querySelector('textarea[name="query"]');
    if (textarea) {
      textarea.focus();
    }
  }, []);
};
